export default __webpack_public_path__ + "static/media/ZipLetterLogo.1546de3a.png";